import styled from 'styled-components';
import { InfoCircle } from '@carvana/icons';

const ToolTipIcon = styled(InfoCircle)`
  color: ${(props) => props.theme.color.neutral.v500};
  margin: 0 10px;
  display: flex;
  flex-direction: column;
  align-items: center;

  svg {
    width: 16px;
    height: 16px;
    fill: ${(props) => props.theme.color.neutral.v100};
  }
`;

export default ToolTipIcon;
